module.exports = __webpack_public_path__ + "img/nira-logo.00b4280b.jpg";